export enum ChatResultStatus  { 
  SUCCESS = 0, 
  ERROR_UNKNOWN = 1, 
  ERROR_QUESTION_TOO_LONG = 2, 
  ERROR_RATE_LIMIT = 3, 
  ERROR_STILL_BUSY = 4, 
  ERROR_NO_BOT_ANSWER = 5,
  ERROR_CONTENT_FILTER = 6,
}